import { defineMessages } from "@formatjs/intl";

export const messages = defineMessages({
  G2_P3_Tab1_Title: {
    id: `guide02.page03.tab01.title`,
  },
  G2_P3_Tab2_Title: {
    id: `guide02.page03.tab02.title`,
  },
  G2_P3_Tab3_Title: {
    id: `guide02.page03.tab03.title`,
  },
  G2_P3_Tab4_Title: {
    id: `guide02.page03.tab04.title`,
  },
  G2_P3_Tab5_Title: {
    id: `guide02.page03.tab05.title`,
  },

  G2_P3_S1_Title: {
    id: `guide02.page03.slide01.title`,
  },
  G2_P3_S1_Description: {
    id: `guide02.page03.slide01.description`,
  },
  G2_P3_S1_P1_Title: {
    id: `guide02.page03.slide01.p1.title`,
  },
  G2_P3_S1_P1_Description: {
    id: `guide02.page03.slide01.p1.description`,
  },
  G2_P3_S1_P2_Title: {
    id: `guide02.page03.slide01.p2.title`,
  },
  G2_P3_S1_P2_Description: {
    id: `guide02.page03.slide01.p2.description`,
  },
  G2_P3_S1_P3_Title: {
    id: `guide02.page03.slide01.p3.title`,
  },
  G2_P3_S1_P3_Description: {
    id: `guide02.page03.slide01.p3.description`,
  },
  G2_P3_S1_P4_Description: {
    id: `guide02.page03.slide01.p4.description`,
  },

  G2_P3_S2_Title: {
    id: `guide02.page03.slide02.title`,
  },
  G2_P3_S2_P1_Title: {
    id: `guide02.page03.slide02.p1.title`,
  },
  G2_P3_S2_P1_ButtonLabel: {
    id: `guide02.page03.slide02.p1.buttonLabel`,
  },
  G2_P3_S2_P1_Description: {
    id: `guide02.page03.slide02.p1.description`,
  },
  G2_P3_S2_P2_Title: {
    id: `guide02.page03.slide02.p2.title`,
  },
  G2_P3_S2_P2_Description: {
    id: `guide02.page03.slide02.p2.description`,
  },
  G2_P3_S2_P2_ButtonLabel: {
    id: `guide02.page03.slide02.p2.buttonLabel`,
  },

  G2_P3_S3_Title: {
    id: `guide02.page03.slide03.title`,
  },
  G2_P3_S3_P1_Title: {
    id: `guide02.page03.slide03.p1.title`,
  },
  G2_P3_S3_P1_ButtonLabel: {
    id: `guide02.page03.slide03.p1.buttonLabel`,
  },
  G2_P3_S3_P1_Description: {
    id: `guide02.page03.slide03.p1.description`,
  },
  G2_P3_S3_P2_Title: {
    id: `guide02.page03.slide03.p2.title`,
  },
  G2_P3_S3_P2_Description: {
    id: `guide02.page03.slide03.p2.description`,
  },
  G2_P3_S3_P3_Title: {
    id: `guide02.page03.slide03.p3.title`,
  },
  G2_P3_S3_P3_Description: {
    id: `guide02.page03.slide03.p3.description`,
  },

  G2_P3_S4_Title: {
    id: `guide02.page03.slide04.title`,
  },
  G2_P3_S4_Description: {
    id: `guide02.page03.slide04.description`,
  },

  G2_P3_S5_Title: {
    id: `guide02.page03.slide05.title`,
  },
  G2_P3_S5_Description: {
    id: `guide02.page03.slide05.description`,
  },

  //Modals
  G2_P3_M_NewSession_Title: {
    id: `guide02.page03.modal.newSession.title`,
  },
  G2_P3_M_NewSession_Description: {
    id: `guide02.page03.modal.newSession.description`,
  },

  G2_P3_M_MasterBus_Title: {
    id: `guide02.page03.modal.masterBus.title`,
  },
  G2_P3_M_MasterBus_Description: {
    id: `guide02.page03.modal.masterBus.description`,
  },

  G2_P3_M_RecordingTracks_Title: {
    id: `guide02.page03.modal.recordingTracks.title`,
  },
  G2_P3_M_RecordingTracks_Description: {
    id: `guide02.page03.modal.recordingTracks.description`,
  },
  G2_P3_M_Premaster_Title: {
    id: `guide02.page03.modal.premaster.title`,
  },
  G2_P3_M_Premaster_Description: {
    id: `guide02.page03.modal.premaster.description`,
  },

  G2_P3_M_StereoFoldownAndBinaural_Title: {
    id: `guide02.page03.modal.stereoFoldownAndBinaural.title`,
  },
  G2_P3_M_StereoFoldownAndBinaural_Description: {
    id: `guide02.page03.modal.stereoFoldownAndBinaural.description`,
  },

  G2_P3_M_StereoFoldown_Title: {
    id: `guide02.page03.modal.stereoFoldown.title`,
  },
  G2_P3_M_StereoFoldown_Description: {
    id: `guide02.page03.modal.stereoFoldown.description`,
  },
});
